import {
    Outlet,
    Navigate,
    useLocation
} from "react-router-dom"
import styles from "./Main.module.css"

// import Sidebar from "@/components/layout/Sidebar/Sidebar"
// import { Navbar, Footer } from '@/components/layout'

import { ROUTES } from '@/constants/routes'

export function Main() {

    const location = useLocation()

    // Landing page is now at root
    const isLandingPage = location.pathname === "/"

    // Home page (/home) is the election chat - no navbar/footer
    const isHomePage = location.pathname === ROUTES.home

    // PeruAI and Blog pages get full-screen treatment (no navbar/footer)
    const isPeruAIPage = location.pathname === ROUTES.peruai
    const isBlogPage = location.pathname === ROUTES.blog

    if (isLandingPage) {
        return <Navigate to={ROUTES.home} />
    }

    // Landing, PeruAI, and Blog pages get full-screen treatment
    if (isHomePage || isPeruAIPage || isBlogPage) {
        return <Outlet />
    }

    // All other pages get the standard layout with navbar and footer
    return (
        <div className={styles.container}>
            {/* <Sidebar /> */}
            {/* <Navbar /> */}
            <div className={styles.contentWrapper}>
                <Outlet />
                {/* <Footer /> */}
            </div>
        </div>
    )
}
